/* eslint-disable max-lines */
import * as api from './DynamicFormsApi';
import { getClinicId, getNamespace } from '../../utils/storage';
import * as type from './DynamicFormsType';
import { ApiCatchToSentry } from './ApiCatchToSentry';
import { bodyReq } from '../../utils/bodyRequest';

export const getForms =
    (namespace, params, service = api.getForms) =>
    async (dispatch) => {
        const clinicId = getClinicId();
        const editedParams = { ...params, clinic: clinicId, subject_key: 'patient' };

        dispatch({
            type: type.GET_ALL_FORMS.REQUEST
        });
        return await service(namespace, editedParams).then((response) => {
            dispatch({
                type: type.GET_ALL_FORMS.SUCCESS,
                payload: response.data.forms
            });
        });
    };
export const getFormStructure =
    (formName, service = api.getFormStructure) =>
    async (dispatch) => {
        dispatch({
            type: type.GET_FORM_STRUCTURE.REQUEST
        });
        const namespace = getNamespace();
        return await service(formName, namespace).then((response) => {
            dispatch({
                type: type.GET_FORM_STRUCTURE.SUCCESS,
                payload: response.data
            });
            return response;
        });
    };
export const changeVisibleOfField = (name, visible) => (dispatch) => {
    dispatch({
        type: type.CHANGE_VISIBLE_OF_FIELDS,
        payload: { name, visible }
    });
};
export const createNewFormStructure =
    (form, service = api.createNewFormStructure) =>
    async (dispatch) => {
        return await service(form).then((response) => {
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'Form was successfully created.',
                    status: response.status
                }
            });
            dispatch({
                type: type.ADD_NEW_FORM_STRUCTURE,
                payload: response.data
            });
            return response;
        });
    };
export const getEntriesOfAForm =
    (formName, params, service = api.filterFormEntries) =>
    async (dispatch) => {
        dispatch({
            type: type.SET_ENTRIES_OF_A_FORM.REQUEST
        });
        const body = bodyReq(params);
        return await service(formName, body).then((response) => {
            dispatch({
                type: type.SET_ENTRIES_OF_A_FORM.SUCCESS,
                payload: response?.data?.entries
            });
        });
    };

export const getSubjects =
    (service = api.getSubjects) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(namespace)?.then((response) => {
            dispatch({
                type: type.GET_SUBJECTS,
                payload: response.data.subject_keys
            });
        });
    };
export const createFormEntry =
    (formName, form, service = api.createFormEntry) =>
    async (dispatch, getState) => {
        const body = bodyReq(form);
        return await service(formName, body)
            .then((response) => {
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: 'Form entry was successfully added.',
                        status: response.status
                    }
                });
                dispatch({
                    type: type.ADD_NEW_FORM_ENTRY,
                    payload: response.data
                });
                return response;
            })
            .catch((err) => {
                const status = err?.response?.status;
                if (status === 500 || status === 400) {
                    ApiCatchToSentry(err, formName, getState, form);
                }
            });
    };
export const editFormEntry =
    (formName, formEntryId, form, service = api.editFormEntry) =>
    async (dispatch, getState) => {
        const body = bodyReq(form);
        return await service(formName, formEntryId, body)
            .then((response) => {
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: 'Form entry was successfully edited.',
                        status: response.status
                    }
                });
                dispatch({
                    type: type.UPDATE_FORM_ENTRY,
                    payload: response.data
                });
            })
            .catch((err) => {
                const status = err?.response?.status;
                if (status === 500 || status === 400) {
                    ApiCatchToSentry(err, formName, getState, form);
                }
            });
    };
export const isDeletingFormEntry = (payload) => (dispatch) => {
    dispatch({
        type: type.IS_DELETING_FORM_ENTRY,
        payload: payload
    });
};
export const deleteFormEntry =
    (formName, formEntryId, service = api.deleteFormEntry) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(formName, formEntryId, namespace).then((response) => {
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'Form entry was successfully deleted.',
                    status: response.status
                }
            });
            dispatch({
                type: type.REMOVE_FORM_ENTRY,
                payload: formEntryId
            });
            isDeletingFormEntry(false);
        });
    };

export const getFormEntries =
    (params, service = api.getFormEntries) =>
    async (dispatch) => {
        const body = bodyReq(params);
        const { offset } = body;
        if (offset === 0) {
            dispatch({
                type: type.GET_FORM_ENTRIES.REQUEST
            });
            //     dispatch({
            //         type: type.GET_FORM_ENTRIES,
            //         payload: null,
            //         params
            //     });
        }
        dispatch({
            type: type.PENDING__MORE_ENTRIES,
            payload: true
        });

        return await service(body)?.then((response) => {
            dispatch({
                type: type.GET_FORM_ENTRIES.SUCCESS,
                payload: response.data?.entries,
                params
            });
            return response;
        });
    };

export const createFormReport =
    (formName, params, export_origin_clinics, service = api.createFormReport) =>
    async (dispatch) => {
        const body = {
            export_config: bodyReq(params),
            ...(export_origin_clinics !== '0' && { export_origin_clinics: [export_origin_clinics] })
        };
        return await service(formName, body)?.then(() => {
            dispatch({
                type: 'ADD_MESSAGE',
                payload: {
                    text: 'Request to create report created',
                    status: 200
                }
            });
        });
    };
export const getFormReport =
    (formName, service = api.getFormExportFile) =>
    async (dispatch) => {
        return await service(formName)?.then((response) => {
            dispatch({
                type: type.GET_FORM_REPORT,
                payload: {
                    name: formName,
                    export_status: 'G'
                }
            });
            return response;
        });
    };
export const deleteFormExport =
    (formName, service = api.deleteFormExport) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(formName, namespace).then((response) => {
            if (response.status >= 200 && response.status <= 300) {
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: `Form export deleted successfully.`,
                        status: 200
                    }
                });
                dispatch({
                    type: type.DELETE_FORM_EXPORT,
                    payload: formName
                });
            }
        });
    };
export const deleteForm =
    (formName, service = api.deleteForm) =>
    async (dispatch) => {
        const namespace = getNamespace();
        return await service(formName, namespace).then((response) => {
            if (response.status >= 202 && response.status < 400) {
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: 'Form successfully removed.',
                        status: 200
                    }
                });
            }
            dispatch({
                type: type.DELETE_FORM,
                payload: formName,
                status: response.status
            });
        });
    };
export const editForm =
    (formName, form, service = api.editForm) =>
    async (dispatch) => {
        const body = bodyReq(form);
        return await service(formName, body).then((response) => {
            const data = response.data;
            if (response.status === 200) {
                dispatch({
                    type: 'ADD_MESSAGE',
                    payload: {
                        text: 'Form editing completed successfully',
                        status: 200
                    }
                });
            }
            dispatch({
                type: type.EDIT_FORM,
                payload: {
                    name: data.name,
                    title: data.title,
                    description: data.description,
                    export_file: data.export_file,
                    export_requested_at: data.export_requested_at,
                    export_status: data.export_status,
                    export_creator: data.export_creator,
                    export_config: data.export_config,
                    order: data.order,
                    clinics: data.clinics
                }
            });
            return response;
        });
    };

export const sortForms =
    (prevData, data, service = api.sortForms) =>
    async (dispatch) => {
        const nameSpace = getNamespace();
        dispatch({
            type: type.SORT_FORMS,
            payload: data
        });
        let forms = [];
        forms = data.map((item) => ({ name: item.name, order: item.order }));
        if (forms.length) {
            return await service(nameSpace, forms).catch((error) => {
                if (error) {
                    dispatch({
                        type: type.SORT_FORMS,
                        payload: prevData
                    });
                }
            });
        }
    };
export const reorderForm =
    (prevData, formName, content, service = api.editForm) =>
    async (dispatch) => {
        dispatch({
            type: type.REORDER_FORM,
            payload: content
        });
        const body = bodyReq(content);
        return await service(formName, body).catch((error) => {
            if (error) {
                dispatch({
                    type: type.REORDER_FORM_FAILURE,
                    payload: prevData
                });
            }
        });
    };

export const uploadMedia =
    (file, formName, fieldName, service = api.uploadMedia) =>
    async (dispatch) => {
        const namespace = getNamespace();
        const formData = new FormData();
        formData.append('file', file);
        formData.append('field_name', fieldName);
        formData.append('namespace', namespace);
        dispatch({
            type: type.UPLOAD_MEDIA_REQUEST,
            payload: {
                formName,
                fieldName,
                url: null
            }
        });
        return await service(formName, formData)
            .then((response) => {
                dispatch({
                    type: type.UPLOAD_MEDIA_SUCCESS,
                    payload: {
                        formName,
                        fieldName,
                        url: response?.data?.file
                    }
                });
            })
            .catch(() => {
                dispatch({
                    type: type.UPLOAD_MEDIA_ERROR,
                    payload: {
                        formName,
                        fieldName
                    }
                });
            });
    };
